import React, { useEffect, useState, useMemo, useRef } from "react";
import { FaPlus, FaTrash, FaTrashAlt } from "react-icons/fa";
import { TableContainer } from "@mui/material";
import { Icon } from "@iconify/react";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import { DesignServices } from "@mui/icons-material";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { DiamondPopUpFields } from "Components/support/Allfields/diamondFields";
import Select from "react-select";
import { generateDropDownList } from "utils/helpers";
import { StonePopUpFields } from "Components/support/Allfields/Stonepopup";

const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "35px",
    height: "30px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const defaultValue = {
  StoneName: "",
  StoneShape: "",
  StoneColor: "",
  StoneSize: "",
  StoneWeight: "",
  StoneRateKarate: "",
  StonePieces: "",
  StoneRatePiece: "",
  StoneAmount: "",
  StoneSettingType: "",
  StoneCertificate: "",
  StonePacket: "",
  StoneBox: "",
  Description: "",
};
const SingleStonePopUpNew = ({
  addStone,
  itemlist,
  index,
  onClose,
  stonemaster,
  dropdownListData,
  Stones,
  StonePieces,
}) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      stones: Stones?.length > 0 ? Stones : [defaultValue],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "stones", // This matches the key in `defaultValues`
  });

  console.log(fields);
  const stoneWeights =
    watch("stones", []).map((stone) => stone.StoneWeight) || [];
  const stoneRateCarates =
    watch("stones", []).map((stone) => stone.StoneRateKarate) || [];
  const stoneAmounts =
    watch("stones", []).map((stone) => stone.StoneAmount) || [];
  const stoneRatePiece =
    watch("stones", []).map((stone) => stone.StoneRatePiece) || [];
  const stonePiece =
    watch("stones", []).map((stone) => stone.StonePieces) || [];

  const localfields = useMemo(() => toPlainFields(StonePopUpFields), []);

  const [itemfields, setItemfields] = useState(() => {
    // Initialize fields with defaults
    const updatedFields = localfields?.map((localField) => ({
      ...localField,
      value: "", // Initialize value as empty string
      label: localField.label || "Default Label",
      placeholder: localField.placeholder || "Enter value",
    
      priority: localField.priority || 1,
      visibility: localField.visibility,
      place: localField.place,
    }));
    return updatedFields;
  });

  useEffect(() => {
    // Loop through all the rows to calculate DiamondAmount
    if (stoneWeights?.length && stoneRateCarates?.length) {
      stoneWeights.forEach((weight, index) => {
        const rate = stoneRateCarates[index];
        if (weight && rate) {
          // Calculate the DiamondAmount
          const amount = parseFloat(weight) * parseFloat(rate);
          // Only update if the calculated amount is different from the existing one
          const existingAmount = watch(`stones.${index}.StoneAmount`);
          if (existingAmount !== amount.toFixed(2)) {
            setValue(`stones.${index}.StoneAmount`, amount.toFixed(2));
          }
        }
      });
    }
    if (stonePiece?.length && stoneRatePiece?.length) {
      stonePiece.forEach((piece, index) => {
        const rate = stoneRatePiece[index];
        if (piece && rate) {
          // Calculate the DiamondAmount
          const amount = parseFloat(piece) * parseFloat(rate);
          // Only update if the calculated amount is different from the existing one
          const existingAmount = watch(`stones.${index}.StoneAmount`);
          if (existingAmount !== amount.toFixed(2)) {
            setValue(`stones.${index}.StoneAmount`, amount.toFixed(2));
          }
        }
      });
    }
  }, [
    stoneWeights,
    stoneRateCarates,
    stonePiece,
    stoneRatePiece,
    setValue,
    watch,
  ]);

  const handleSave = () => {
    // onSave(stoneDetails); // Pass updated stone details to the parent
    // onClose(); // Close the popup after saving
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data) => {
    console.log(data);
    addStone(data);
  };

  useEffect(() => {
    fields?.forEach((_, stoneIndex) => {
      const StoneRateKarate = watch(`stones.${stoneIndex}.StoneRateKarate`, "");
      const StoneRatePiece = watch(`stones.${stoneIndex}.StoneRatePiece`, "");

      if (StoneRateKarate) {
        setValue(`stones.${stoneIndex}.StoneRatePiece`, "");
      }
      if (StoneRatePiece) {
        setValue(`stones.${stoneIndex}.StoneRateKarate`, "");
      }
    });
  }, [fields, watch, setValue]);

  const total = useMemo(() => {
    const totalAmount = stoneAmounts?.reduce((curr, acc) => {
      return +curr + +acc;
    }, 0);
    const totalPieces = stonePiece?.reduce((curr, acc) => {
      return +curr + +acc;
    }, 0);
    const totalWeight = stoneWeights?.reduce((curr, acc) => {
      return +curr + +acc;
    }, 0);

    return {
      totalAmount: totalAmount?.toFixed(3),
      totalPieces: totalPieces?.toFixed(3),
      totalWeight: totalWeight?.toFixed(3),
    };
  }, [stonePiece, stoneWeights, stoneAmounts]);

  const firstFieldRefStone = useRef(null);

  useEffect(() => {
    // Focus on the first field when the popup opens
    if (firstFieldRefStone.current) {
      firstFieldRefStone.current.focus();
    }
  }, []);

  const trRef = useRef([]);

  const handleEnterKey = (e, stoneIndex, fieldIndex) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent the default Enter key behavior
  
      // Get total fields and rows
      const totalFields = itemfields.length;
      const totalRows = fields.length;
  
      if (fieldIndex < totalFields - 1) {
        // Move to the next field in the same row
        const nextFieldName = `diamonds.${stoneIndex}.${itemfields[fieldIndex + 1].key}`;
        const nextField = document.querySelector(`[name="${nextFieldName}"]`);
        if (nextField) {
          nextField.focus();
        }
      } else if (stoneIndex < totalRows - 1) {
        // Move to the first field of the next row
        const nextRowFirstFieldName = `diamonds.${stoneIndex + 1}.${itemfields[0].key}`;
        const nextRowFirstField = document.querySelector(
          `[name="${nextRowFirstFieldName}"]`
        );
        if (nextRowFirstField) {
          nextRowFirstField.focus();
        }
      } else if (
        stoneIndex === totalRows - 1 &&
        fieldIndex === totalFields - 1
      ) {
        // Last field of the last row: Add a new row and focus on its first field
        append(defaultValue);
        setTimeout(() => {
          const newRowFirstFieldName = `diamonds.${stoneIndex + 1}.${itemfields[0].key}`;
          const newRowFirstField = document.querySelector(
            `[name="${newRowFirstFieldName}"]`
          );
          if (newRowFirstField) {
            newRowFirstField.focus();
          }
        }, 0); // Slight delay to ensure the DOM is updated
      }
    }
  };
  // Helper function to find the next enabled field
  const getNextEnabledField = (stoneIndex, fieldIndex) => {
    const totalFields = itemfields.length;

    for (let i = fieldIndex; i < totalFields; i++) {
      const field = itemfields[i];
      const fieldName = `stones.${stoneIndex}.${field.key}`;
      const fieldElement = document.querySelector(`[name="${fieldName}"]`);

      if (fieldElement && !fieldElement.disabled) {
        return fieldElement;
      }
    }

    return null; // Return null if no enabled field is found
  };

  console.log(itemfields);
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div
          className="modal-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 10px",
          }}
        >
          <p style={{ fontSize: "14px", fontWeight: "bold" }}>
            Add Stone Details
          </p>
          <Icon
            style={{
              cursor: "pointer",
              fontSize: "26px",
              color: "#627282",
            }}
            icon="carbon:close-filled"
            onClick={onClose} // Close the modal
          />
        </div>
        <div
          style={{
            flex: "1", // Allow the table container to grow and fill space
            overflowY: "auto", // Enable vertical scrolling only
            overflowX: "hidden", // Prevent horizontal scrolling
            maxHeight: "60vh",
          }}
        >
          <table className="diamond-table">
            <thead>
              <tr>
                {itemfields
                  ?.filter(
                    (field) =>
                      field?.place === "top" &&
                      field?.visibility !== "Hidden" &&
                      field?.IsVisible && field?.label != "Action"
                  )
                  ?.sort((a, b) => a.priority - b.priority)
                  ?.map((field) => (
                    <th
                      key={field.key}
                      style={{
                        width: `${field.key === "StoneName" ? "150px" : ""}`,
                        minWidth: `${field.key === "StoneName" ? "150px" : ""}`,
                        textAlign: "left",
                      }}
                    >
                      {field.label || field.key}
                    </th>
                  ))}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {fields?.map((stone, stoneIndex) => (
                <tr key={stone?.id}>
                  {itemfields
                    ?.filter(
                      (field) =>
                        field?.place === "top" &&
                        field?.visibility !== "Hidden" &&
                        field?.IsVisible && field?.label != "Action"
                    )
                    ?.sort((a, b) => a.priority - b.priority)
                    ?.map((field, fieldIndex) => {
                      const stoneWeight = watch(
                        `stones.${stoneIndex}.StoneWeight`
                      );
                      const stoneRate = watch(
                        `stones.${stoneIndex}.StoneRateKarate`
                      );
                      const stonePieces = watch(
                        `stones.${stoneIndex}.StonePieces`
                      );
                      const ratePerPiece = watch(
                        `stones.${stoneIndex}.StoneRatePiece`
                      );
                      const StoneRateKarate = watch(
                        `stones.${stoneIndex}.StoneRateKarate`,
                        ""
                      );
                      const StoneRatePiece = watch(
                        `stones.${stoneIndex}.StoneRatePiece`,
                        ""
                      );

                      return (
                        
                        <td
                          onKeyDown={(e) =>
                            handleEnterKey(e, stoneIndex, fieldIndex)
                          }
                          key={field.key}
                          ref={(el) => (trRef.current[stoneIndex] = el)}
                          style={{
                            width:
                              field.type === "dropdown" ||
                              field.type === "searchDropdown"
                                ? "300px"
                                : "auto",
                          }}
                        >
                          {field.type === "dropdown" ||
                          field.type === "searchDropdown" ? (
                            <select
                              name={`stones.${stoneIndex}.${field.key}`}
                              {...register(`stones.${stoneIndex}.${field.key}`)}
                              ref={(e) => {
                                register(
                                  `stones.${stoneIndex}.${field.key}`
                                ).ref(e);
                                if (stoneIndex === 0 && fieldIndex === 0)
                                  firstFieldRefStone.current = e;
                              }}
                              disabled={field.visibility === "ReadOnly"}
                              style={{
                                background:
                                  field.visibility !== "ReadOnly"
                                    ? "white"
                                    : "#f0f0f0",
                                width: "100%",
                                border: "1px solid #ddd",
                              }}
                            >
                              {generateDropDownList(
                                field,
                                dropdownListData
                              )?.map((item) => (
                                <option key={item?.value} value={item?.value}>
                                  {item?.label}
                                </option>
                              ))}
                            </select>
                          ) : field.type === "number" ||
                          field.type=="inputselect"||
                          field.type=="inputdecimal"||
                          field.type=="inputtext"||
                            field.type === "text" ? (
                            <div style={{ position: "relative" }}>
                              <input
                                type={field.type}
                                name={`stones.${stoneIndex}.${field.key}`}
                                ref={
                                  stoneIndex === 0 && fieldIndex === 0
                                    ? firstFieldRefStone
                                    : null
                                } // Apply ref to the first field
                                disabled={
                                  field.visibility === "ReadOnly" ||
                                  (StoneRateKarate &&
                                    field.key === "StoneRatePiece") ||
                                  (StoneRatePiece &&
                                    field.key === "StoneRateKarate") ||
                                  (field.key === "StonePieces" && StonePieces)
                                }
                                {...register(
                                  `stones.${stoneIndex}.${field.key}`,
                                  {
                                    validate: (value) => {
                                      if (
                                        field.key === "StoneRatePiece" &&
                                        StoneRateKarate &&
                                        value
                                      ) {
                                        return "Cannot set both StoneRateKarate and StoneRatePiece";
                                      }
                                      if (
                                        field.key === "StoneRateKarate" &&
                                        StoneRatePiece &&
                                        value
                                      ) {
                                        return "Cannot set both StoneRatePiece and StoneRateKarate";
                                      }
                                      return true;
                                    },
                                  }
                                )}
                                style={{
                                  background:
                                    field.visibility === "ReadOnly" ||
                                    (StoneRateKarate &&
                                      field.key === "StoneRatePiece") ||
                                    (StoneRatePiece &&
                                      field.key === "StoneRateKarate") ||
                                    (field.key === "StonePieces" && StonePieces)
                                      ? "#f0f0f0"
                                      : "white",
                                  width: "100%",
                                  border: "1px solid #ddd",
                                }}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </td>
                      );
                    })}
                  <td
                    onKeyDown={(e) => handleEnterKey(e, stoneIndex, fieldIndex)}
                    ref={(el) => (trRef.current[stoneIndex] = el)}
                    align="center"
                  >
                    <FaTrashAlt
                      size={24}
                      style={{ cursor: "pointer", color: "#A9A9A9" }}
                      onClick={() => remove(stoneIndex)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                {itemfields?.filter?.((item)=>item?.label != "Action")?.map((field) => (
                  <td key={field.key}>
                    {field.key === "StoneWeight"
                      ? total?.totalWeight
                      : field.key === "StoneAmount"
                      ? total?.totalAmount
                      : field.key === "StonePieces"
                      ? total?.totalPieces
                      : ""}
                  </td>
                ))}
                <td>Total</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0px",
          }}
        >
          <button onClick={handleSave} className="save-button" type="button">
            Save
          </button>
          <button onClick={onClose} className="cancel-button" type="button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleStonePopUpNew;
